var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentsBgLayer2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1769,
    height: 287,
    viewBox: "0 0 1769 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.854736H1769V281.803C1769 284.564 1766.76 286.803 1764 286.803H4.99999C2.23857 286.803 0 284.564 0 281.803V0.854736Z",
    fill: "#0C3330"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_14",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1769,
    height: 287
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.854736H1769V281.803C1769 284.564 1766.76 286.803 1764 286.803H4.99999C2.23857 286.803 0 284.564 0 281.803V0.854736Z",
    fill: "#0C3330"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M705.176 349.808C580.167 841.954 82.2421 1417.75 -429.838 1254.59C-941.918 1091.43 -1255.7 560.193 -1130.69 68.0465C-1005.68 -424.1 -489.221 -690.794 22.8595 -527.631C534.94 -364.468 830.185 -142.338 705.176 349.808Z",
    fill: "#6DFFFE",
    fillOpacity: 0.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsBgLayer2);
export default __webpack_public_path__ + "static/media/payments_bg_layer2.783ce624412e2e5bfa79a66ed2ac48db.svg";
export { ForwardRef as ReactComponent };